export default __webpack_public_path__ + "static/media/doallon-text.9a29333f.svg";